import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row, Statistic, Tooltip } from "antd";

const formatCurrency = (value) => {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export default function MainMetrics({
  data,
  isLoading,
  kpis,
  permanenceData,
  revenueKPIsData,
}) {
  return (
    <Card
      loading={isLoading}
      title="Principais métricas"
      align="center"
      style={{
        width: "85%",
      }}
      styles={{
        header: {
          backgroundColor: "#d0d6e2",
        },
      }}>
      <Row
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "32px",
          maxWidth: "100%",
        }}>
        {kpis?.map((kpi) => (
          <Col
            key={kpi.key}
            style={{
              flex: "1 1 calc(20%)",
              minWidth: "200px",
            }}>
            <Card
              bordered={true}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}>
              <Statistic
                style={{
                  minWidth: 130,
                }}
                title={
                  <>
                    {kpi.title}
                    <Tooltip title={kpi.description}>
                      <InfoCircleOutlined style={{ marginLeft: 10 }} />
                    </Tooltip>
                  </>
                }
                value={
                  kpi.key === "receita_hora"
                    ? permanenceData && revenueKPIsData
                      ? revenueKPIsData.faturamento_total /
                        permanenceData.kpi_data.total_occupied_time /
                        60
                      : 0
                    : kpi.key.includes("percent")
                      ? (data?.[kpi.key] || 0) * 100
                      : data?.[kpi.key] || 0
                }
                precision={kpi.suffix.includes("percent") ? 2 : 0}
                suffix={kpi.suffix}
                formatter={
                  kpi.formatter === "currency" ? formatCurrency : undefined
                }
              />
            </Card>
          </Col>
        ))}
      </Row>
    </Card>
  );
}
